const INITIAL_BADGE_COLORS = [
  'bg-purple-300',
  'bg-sky-300',
  'bg-green-300',
  'bg-red-300',
] as const;

/**
 * Deterministically map a name to one of the predefined Tailwind color classes.
 */
export function getInitialBadgeColor(name: string | null | undefined) {
  if (!name) {
    return INITIAL_BADGE_COLORS[0];
  }

  let hash = 2;
  for (let i = 0; i < name.length; i += 1) {
    const char = name[i]?.toLowerCase() ?? '';
    if (char >= 'a' && char <= 'z') {
      hash += char.charCodeAt(0) - 96; // a -> 1, b -> 2, ...
    } else if (char >= '0' && char <= '9') {
      hash += Number(char);
    }
  }
  hash += name.length;

  const index = Math.abs(hash) % INITIAL_BADGE_COLORS.length;
  return INITIAL_BADGE_COLORS[index];
}
